import {
  Dialog,
  FormControl,
  DialogTitle,
  DialogContent,
  Divider,
  Typography,
  CircularProgress,
  DialogActions,
  Button,
  Grid,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import { config } from "process";
import { useState } from "react";
import Form from "../../components/Form";
import { error } from "console";

interface Props {
  handleClose: () => void;
  open: boolean;
}

export const SettingsModal = ({ handleClose, open }: Props) => {
  const [isLoading, setLoading] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState<boolean | undefined>(
    undefined,
  );
  const [submitMessage, setSubmitMessage] = useState("");

  return (
    <Dialog open={open} onClose={() => handleClose()} maxWidth="md" fullWidth>
      <FormControl error={true} required>
        <Form onSubmit={() => {}}>
          <DialogTitle sx={{ display: "flex" }}>
            Pas bot parameters aan
          </DialogTitle>
          <DialogContent>
            <Grid container columnSpacing={6}>
              {/* {Object.entries(config)
                .filter(
                  ([configKey, configValue]) =>
                    configValue.category === "GENERAL",
                )
                .map(([configKey, _]) =>
                  renderFinetuneInput(
                    configKey,
                    finetuneValues[configKey] as number,
                  ),
                )} */}

              <Grid container size={{ xs: 12, md: 6 }}>
                <Grid size={{ xs: 12, md: 8 }} sx={{ margin: "auto" }}>
                  {"Leverage"}
                  <Grid
                    sx={{ visibility: { xs: "hidden", md: "inherit" } }}
                  ></Grid>
                  <Typography variant="caption" display="block">
                    {"Met hoeveel leverage er getrade moet worden"}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ margin: "auto" }}>
                  <Stack direction="row">
                    <TextField
                      sx={{ m: 1 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">{"%"}</InputAdornment>
                        ),
                      }}
                      // onChange={(e) =>
                      //   changeFinetuneValue(finetuneKey, e.target.value)
                      // }
                      fullWidth
                      // value={value}
                      // required={!canBeUndefined}
                      size="small"
                      variant="standard"
                      // name={finetuneKey}
                      // error={error !== ""}
                    />
                    <Grid sx={{ marginTop: "10px" }}>
                      <Typography variant="caption">{"10"}</Typography>
                    </Grid>
                  </Stack>
                </Grid>
              </Grid>

              {/* <Grid item xs={12} sx={{ mb: 1, mt: 2 }}>
                <Divider />
              </Grid> */}

              {/* {Object.entries(config)
                .filter(
                  ([configKey, configValue]) =>
                    configValue.category === "ADVANCED",
                )
                .map(([configKey, _]) =>
                  renderFinetuneInput(
                    configKey,
                    finetuneValues[configKey] as number,
                  ),
                )} */}
            </Grid>

            <Typography variant="h6" color="success.main">
              {submitSuccess === true && submitMessage}
            </Typography>

            <Typography variant="h6" color="error">
              {submitSuccess === false && submitMessage}
            </Typography>

            {isLoading && <CircularProgress />}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleClose()} disabled={isLoading}>
              {submitSuccess === undefined ? "Cancel" : "Sluit"}
            </Button>
            <Button type="submit" disabled={isLoading}>
              Opslaan
            </Button>
          </DialogActions>
        </Form>
      </FormControl>
    </Dialog>
  );
};
